

'use strict';
angular.module('pulianiBookStoreApp')
  .controller('LegalDisclaimerCtrl', function ($scope,$rootScope) {
$rootScope.title='Legal Disclaimer';


});

